//
// This is file for the temporary dummy agenda dashboard, which exists just for us developers
// to check the current normalizded event data. We should not build on this.
// So it's not build to our usual standards (is very far off even), so ignore any ugly, hacky and
// unused code.
//

import polpoApi from '@/api/polpoApi';

// TODO fix this:
export default {

  getById: async (id, query, origin) => {
    const args = {};
    if (query) { args.query = query; }
    if (origin) { args.origin = origin; }
    return polpoApi.postById('event', id, args);
  },

  // getXlsxById: async (id) => polpoApi.getExcel(`agendas/export/xlsx/${id}`),

  // TODO: remove when the backend can parse query from body in post requests
  getAll: async (query, filters, startDate, endDate, origin) => polpoApi.post(`event/timeline?query=${encodeURIComponent(query)}${startDate ? `&startDateTime=${startDate}` : ''}${endDate ? `&endDateTime=${endDate}` : ''}${origin ? `&origin=${origin}` : ''}`, {
    sourceIds: filters,
  }),

};
